export default __webpack_public_path__ + "assets/images/e1539bb01f7908340b82be8469029176.svg";